import React from "react";
import { useNavigate } from "react-router-dom";

import "../styles/PageNotFound.css";

const PageNotFound = ({
  title = "Page Not Found",
  message = "The page you are looking for doesn't exist or may have been moved."
}) => {

  const navigate = useNavigate();

  return (
    <div className="not-found-page">

      <div className="not-found-card">

        <div className="not-found-icon">
          <i className="bi bi-compass"></i>
        </div>

        <div className="not-found-code">
          404
        </div>

        <h2>
          {title}
        </h2>

        <p>
          {message}
        </p>

        <div className="not-found-actions">
          <button
            className="btn btn-primary"
            onClick={() => navigate('/')}
          >
            <i className="bi bi-house m-2"></i>
            Go Back
          </button>

        </div>

      </div>

    </div>
  );

};

export default PageNotFound;